
import axios from 'axios';
import Router from '../routes';
import store from '../store';

const instance = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  params: {}
});

instance.interceptors.request.use((request) => {
  const token = store.getters['token/token'];

  if (token) {
    request.headers.Authorization = `Bearer ${token}`;
  }

  return request;
}, (error) => Promise.reject(error));

instance.interceptors.response.use(
  (response) => response,
  (error) => {
    const response = error && error.response;

    // Network / CORS failures have no response — avoid crashing the app
    if (!response) {
      return Promise.reject(error);
    }

    const { status, data } = response;
    const message = data && data.message;

    if (status === 401 || status === 500 || status === 502) {
      store.dispatch('error/updateState', { status, message });
      Router.push({ name: 'error', params: { status } });
    }

    return Promise.reject(response);
  }
);

export default instance;
